import { UseFormReturn } from "react-hook-form";
import { useMilestone } from "@pages/Program/components/milestones/utils/useMilestone";
import { MilestonePayload } from "@shared/interfaces/ProgramFiles";
import { useSearchParams } from "react-router-dom";

interface SaveMilestoneOptions {
  milestoneId?: string;
}

const useHandleSaveMilestone = (
  options: SaveMilestoneOptions,
  methods: UseFormReturn<any>
) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { saveMilestone } = useMilestone();

  const handleSaveMilestone = async (payload: MilestonePayload) => {
    try {
      await saveMilestone(payload, { milestoneId: options.milestoneId });

      methods.reset();
      setSearchParams({});
    } catch (error) {
      console.error("Error saving milestone:", error);
    }
  };

  return handleSaveMilestone;
};

export default useHandleSaveMilestone;
